import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://rapidmind-69fpsug1l-rapidmind-s-projects.vercel.app',
  withCredentials: true,            // Optional: if you're using cookies
  timeout: 30000, // 30 second timeout for production
});

// Add request interceptor to include JWT token in Authorization header
apiClient.interceptors.request.use(
  (config) => {
    // Skip adding JWT token if X-Override-Auth header is present (used for Firebase auth)
    if (config.headers['X-Override-Auth'] === 'true') {
      return config;
    }

    const token = localStorage.getItem('token');
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 errors (token expired)
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid, clear local storage and redirect to login
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // Optionally redirect to login page
      // window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient;
